import React, { useEffect, useMemo, useState } from 'react';
import Table from '@awp/components/table';
import { CodeTableEditorProps, CodeTableRow } from '../Interfaces/CodeTableInterfaces';

const CodeTableEditor: React.FC<CodeTableEditorProps> = ({
  id,
  name,
  observationTypeId,
  codeTableData,
  setCodeTableData,
  isAvalancheObs,
  errors,
  setErrors,
  props,
  codeTableService,
  validateTable,
}) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (codeTableData?.length === 0) {
      handleAddRow();
    }
  }, [codeTableData]);

  useEffect(() => {
    if (codeTableData != null && codeTableData?.length > 0) {
      validateTable(codeTableData);
    }
  }, [isAvalancheObs]);

  const updateRow = (rowId: string | number, field: keyof CodeTableRow, value: any) => {
    setCodeTableData((prev) => {
      if (!prev) return [];
      const updated = prev?.map((row) =>
        row.Id === rowId
          ? {
              ...row,
              [field]: field === 'EndTimestamp' ? (value ? new Date() : null) : value,
            }
          : row,
      );
      validateTable(updated);
      return updated;
    });
  };

  const handleAddRow = () => {
    const hasTemp = codeTableData?.some((row) => typeof row.Id === 'string' && row.Id.startsWith('temp-'));
    if (hasTemp && !validateTable(codeTableData)) return;

    const newRow: CodeTableRow = {
      Id: `temp-${Date.now()}`,
      ObservedCharacterValue: '',
      DisplayedMeaning: '',
      DisplayedHint: '',
      EndTimestamp: null,
      DisplayOrder: null,
      ObservationTypeId: observationTypeId,
      ConcurrencyControlNumber: 0,
    };

    const updated = [...(codeTableData ?? []), newRow];
    setCodeTableData(updated);
    if (hasTemp) validateTable(updated);
  };

  const handleRemoveRow = (rowId: string | number) => {
    const updated = codeTableData?.filter((row) => row.Id !== rowId);
    setCodeTableData(updated ?? []);
    validateTable(updated ?? []);
  };

  const columns = useMemo(() => {
    return codeTableService.getColumns({
      mode: 'editor',
      updateRow,
      handleAddRow,
      handleRemoveRow,
      errors,
      isAvalancheObs,
    });
  }, [codeTableData, errors]);

  return (
    <>
      <div>
        {Object.keys(errors).map((key) => (
          <div key={key} className="text-danger mb-2">
            {errors[key]}
          </div>
        ))}
      </div>
      <Table
        columns={columns}
        data={codeTableData ?? []}
        {...codeTableService.defaultTableProps}
        index={index}
        setIndex={setIndex}
        defaultSortBy="ObservedCharacterValue"
        customClass={'simplebar-code-table'}
      />
    </>
  );
};

export default CodeTableEditor;
